
export function fraudManagement(prefix: string) {
    
    // GLOBAL SETTINGS Menu Routes
    const GLOBAL_SETTINGS_PATH = `${prefix}/global-settings/`;

        // GLOBAL SETTINGS EMITTER SubMenu Routes
    const GLOBAL_SETTINGS_EMITTER_PATH = `${prefix}/global-settings/emitter/`;

        // EMITTER OTHER RULES SubMenu Routes
    const OTHER_RULES_PATH = `${prefix}/global-settings/emitter/other-rules/`;
    const OTHER_RULES_MENU = {
        ROOT: OTHER_RULES_PATH,
        TRIALS_AUTHORIZATION_REJECTED: `${OTHER_RULES_PATH}trials-authorization-rejected`,
        AVAILABLE_TO_SPEND: `${OTHER_RULES_PATH}available-to-spend`,
    }
        
    const GLOBAL_SETTINGS_EMITTER_MENU = {
        ROOT: GLOBAL_SETTINGS_EMITTER_PATH,
        
        RULES: `${GLOBAL_SETTINGS_EMITTER_PATH}rules`,
        
        OTHER_RULES_MENU,
        
        RULES_MANAGEMENT: `${GLOBAL_SETTINGS_EMITTER_PATH}rules-management`,
        
        MOVING_RULES: `${GLOBAL_SETTINGS_EMITTER_PATH}moving-rules`,

    };

    const GLOBAL_SETTINGS_MENU = {
        ROOT: GLOBAL_SETTINGS_PATH,
        
        GLOBAL_SETTINGS_EMITTER_MENU, 

        MCC_RISK: `${GLOBAL_SETTINGS_PATH}mcc-risk`,
        
        COUNTRY_RISK: `${GLOBAL_SETTINGS_PATH}country-risk`,
        
        MCC_RISK_GROUP: `${GLOBAL_SETTINGS_PATH}mcc-risk-group`,
        
    };

    // EMITTER Menu Routes
    const EMITTER_PATH = `${prefix}/emitter/`;
    const EMITTER_MENU = {
        ROOT: EMITTER_PATH,
        LIST_OF_BROKEN_RULES: `${EMITTER_PATH}list-of-broken-rules`,
        LIST_OF_CARDS_BY_BROKEN_RULE: `${EMITTER_PATH}list-of-cards-by-broken-rule/`,
        LIST_OF_SUSPECT_CARDS: `${EMITTER_PATH}list-of-suspect-cards`,
        LIST_OF_BROKEN_RULES_BY_CARD: `${EMITTER_PATH}list-of-broken-rules-by-card/`,
        LIST_OF_SUSPECT_TRANSACTIONS: `${EMITTER_PATH}list-of-suspect-transactions`,
        HOLDER_REFERENTIAL_VALUE: `${EMITTER_PATH}holder-referential-value`,
    };

    return {
        ROOT: prefix,
        GLOBAL_SETTINGS_MENU,
        EMITTER_MENU,
        
    }
}